"use strict";
exports.__esModule = true;
exports.isValidSSN = exports.invalidSSNs = void 0;
exports.invalidSSNs = [
    '987-65-4321',
    '123-45-6789',
    '111-11-1111',
    '222-22-2222',
    '333-33-3333',
    '444-44-4444',
    '555-55-5555',
    '666-66-6666',
    '777-77-7777',
    '888-88-8888',
    '999-99-9999',
    '000-00-0000',
];
var SSN_MAX_LENGTH = 11;
var isValidSSN = function (ssn) {
    var hasCorrectLength = ssn.length === SSN_MAX_LENGTH;
    if (!hasCorrectLength || exports.invalidSSNs.includes(ssn)) {
        return false;
    }
    var ssnValidationExpression = /^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/;
    var ssnFormat = /^(?:\d{3})-(?:\d{2})-(\d{4})$/;
    return ssnValidationExpression.test(ssn) && ssnFormat.test(ssn);
};
exports.isValidSSN = isValidSSN;
